import { useContext } from "react";
import { GameLiftStreamsContext } from "context/session/GameLiftStreamsProvider";
export default function useGameLiftStreams(sessionId: string) {
  const context = useContext(GameLiftStreamsContext);
  if (!context) {
    throw new Error("useGameLiftStreamsContext must be used within a GameLiftStreamsProvider");
  }
  return context;

}
